import { Box } from "@chakra-ui/react";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Home";
import Login from "./Login";
import Recipes from "./Recipes";
import Register from "./Register";
import PrivateRoute from "./PrivateRoute";
import RecipeCrud from "./RecipeCrud";

const AllRoutes = () => {
  
  return (
    <Box>
      <Routes>
        <Route path="/" element={<Home />}>
          Home
        </Route>
        <Route path="/login" element={<Login />}>
          Login
        </Route>
        <Route path="/register" element={<Register />}>
          Register
        </Route>
        <Route path="/recipecrud" element={<PrivateRoute><RecipeCrud /></PrivateRoute>}>
          Recipe Operations
        </Route>
        <Route
          path="/recipes"
          element={
            <PrivateRoute>
              <Recipes />
            </PrivateRoute>
          }
        >
          Recipes
        </Route>
      </Routes>
    </Box>
  );
};

export default AllRoutes;
